import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap/dist/js/bootstrap.bundle.js';
import Header from './components/Header';
import './pages/style.css';
import './pages/responsive.css';
import Footer from './components/Footer';
import Home from './pages/Home';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import Aboutus from './pages/Aboutus';
import Contactus from './pages/Contactus';
import ScrollToTop from './components/Scrolltop';
import Eprservices from './pages/Eprservices';
import Hdpegranules from './pages/Hdpegranules';
import LLdpegranules from './pages/LLdpegranules';
import PPCPgranules from './pages/PPCPgranules';
import Hdpegranulesdetails from './pages/Hdpegranulesdetails';
import LLdpegranulesdetails from './pages/LLdpegranulesdetails';
import PPCPgranulesdetails from './pages/PPCPgranulesdetails';
import Customcompounding from './pages/Customcompounding';
import { Hdpedana } from './pages/Hdpedana';
import Ldpegranules from './pages/Ldpegranules';
import LDPEDana from './pages/LDPEDana';
import Lldpedana from './pages/Lldpedana';
import PPDana from './pages/PPDana';
import PPGranules from './pages/PPGranules';
import PPCPDana from './pages/PPCPDana';
import PPDanaStateCityDetails from './pages/PPDanaStateCityDetails';
import XMLUrlList from './pages/seo/XMLUrlList';
import XMLPage from './pages/seo/XMLPage';
import matchingProducts from './data/StateCityData/ProductsData.json';
import statesCitiesData from './data/StateCityData/CityData.json';
import Sitemap from './pages/Sitemap';

function App() {
  return (
    <BrowserRouter>
      <AppWithLocation />
    </BrowserRouter>
  );
}

function AppWithLocation() {
  const location = useLocation(); 

  const isSitemapPage = location.pathname.startsWith('/xml_sitemap');

  return (
    <>
      {!isSitemapPage && <Header />} 
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about-us" element={<Aboutus />} />
        <Route path="/sitemap" element={<Sitemap />} />
        <Route path="/contact-us" element={<Contactus />} />
        <Route path="/epr-services" element={<Eprservices />} />
        <Route path="/hdpe-granules" element={<Hdpegranules />} />
        <Route path="/hdpe-granules/:id" element={<Hdpegranulesdetails />} />
        <Route path="/lldpe-granules" element={<LLdpegranules />} />
        <Route path="/lldpe-granules/:id" element={<LLdpegranulesdetails />} />
        <Route path="/ppcp-granules" element={<PPCPgranules />} />
        <Route path="/ppcp-granules/:id" element={<PPCPgranulesdetails />} />
        <Route path="/custom-compounding" element={<Customcompounding />} />
        <Route path="/hdpe-dana" element={<Hdpedana />} />
        <Route path="/ldpe-granules" element={<Ldpegranules />} />
        <Route path="/ldpe-dana" element={<LDPEDana />} />
        <Route path="/lldpe-dana" element={<Lldpedana />} />
        <Route path="/pp-granules" element={<PPGranules />} />
        <Route path="/ppcp-dana" element={<PPCPDana />} />
        <Route path="/pp-dana" element={<PPDana />} />
        <Route path="/:slug" element={<PPDanaStateCityDetails />} />

        <Route path="/xml_sitemap" element={<XMLUrlList matchingProducts={matchingProducts} statesCitiesData={statesCitiesData} />} />
        <Route path="/xml_sitemap/:pageNumber" element={<XMLPage matchingProducts={matchingProducts} statesCitiesData={statesCitiesData} />} />
      </Routes>
      {!isSitemapPage && <Footer />}
      <ScrollToTop />
    </>
  );
}

export default App;
